/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsersImportJobsResponse } from '../../models/users-import-jobs-response';

export interface GetUsersImport$Params {
  'Active-Tenant-Identifier': string;
}

export function getUsersImport(http: HttpClient, rootUrl: string, params: GetUsersImport$Params, context?: HttpContext): Observable<StrictHttpResponse<UsersImportJobsResponse>> {
  const rb = new RequestBuilder(rootUrl, getUsersImport.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UsersImportJobsResponse>;
    })
  );
}

getUsersImport.PATH = '/users-import';
